

function SocialNetwork({ socialNetwork, chooseSocialNetwork }) {
    return (
        <div className="flex flex-row-reverse items-center justify-between mb-4">
            <p> : شبکه اجتماعی</p>
            <select
                className="bg-white border border-slate-200 rounded p-1 w-9/12 drtl"
                value={socialNetwork}
                onChange={(e) => chooseSocialNetwork(e.target.value)}
            >
                <option value="instagram">اینستاگرام</option>
                <option value="telegram">تلگرام</option>
                <option value="youtub">یوتیوب</option>
                <option value="aparat">آپارات</option>
                <option value="web">وب</option>
            </select>
        </div>
    )
}
export default SocialNetwork;